<template>
  <nav>
    <div class="nav-container-sticky container">
      <div class="nav-options-sticky">
        <div>
        <NavOptions/>
        </div>

        <div class="nav-countdown">
           Conference opens in: {{textDay}} days
        </div>
      </div>
      <div class="nav-mmu-logo-sticky">

      </div>
    </div>
  </nav>
</template>

<script setup>


    import NavOptions from "@/components/NavOptions"
    import { ref } from 'vue'
    import { date } from 'quasar'

    const menuOpenHandler = (anchor) => {
        console.log(anchor)
        document.getElementById(anchor).scrollIntoView({behavior: "smooth"});   
    } 

    let textDay = ref(0)
    let textHour = ref(0)
    let textMinute = ref(0)
    let textSecond = ref(0)

    const date1 = ref(new Date().getTime())
    const date2 = ref(new Date('march 31, 2023 11:59:00'))
    const unit = ref('months')

    const diff = ref(date.getDateDiff(date2.value, date1.value, unit.value))
    // `diff` is 34 (days)
  
    const countdown = () => {
      
      const submissionCountDate = ref(new Date('June 14, 2023 09:30:00').getTime());

      const now = ref(new Date().getTime())

      const submissionDeadlineGap = ref(submissionCountDate.value - now.value)

      const second = ref(1000)
      const minute = ref(second.value * 60)
      const hour = ref(minute.value * 60)
      const day = ref(hour.value * 24)

      textDay.value = submissionDeadlineGap.value >= 0 ? Math.floor(submissionDeadlineGap.value / day.value) : 0;
      textHour.value = submissionDeadlineGap.value >= 0 ? Math.floor((submissionDeadlineGap.value % day.value) / hour.value) : 0 
      textMinute.value = submissionDeadlineGap.value >= 0 ? Math.floor((submissionDeadlineGap.value % hour.value) / minute.value) : 0
      textSecond.value = submissionDeadlineGap.value >= 0 ? Math.floor((submissionDeadlineGap.value % minute.value) / second.value) : 0

  };

    countdown()

    setInterval(countdown, 1000);


</script>

<style>



</style>